// extracted by mini-css-extract-plugin
export default {"main":"Home_main__m+k9k","btnCV":"Home_btnCV__7ArdO"};